// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__1aCJd","info":"UpdateTermsInfo_info__t6PAE"};